import React from 'react';
import BackgroundImage from '../components/BackgroundImage/BackgroundImage';
import sampleImage from '../assets/background-sample.jpg';
import logoWhite from '../assets/sample-logo.png';
import logo from '../assets/logo.svg';
import CreateAccountForm from '../components/CreateAccountForm/CreateAccountForm';

const SplitBackgroundImage = () => (
  <div className="container-fluid">
    <div className="row min-vh-100">
      <BackgroundImage
        backgroundImage={sampleImage}
        overlayColor="#007affc9"
        heading="The Best React Starter Kits"
        subheading="This template will knock your socks off. Get started quickly with our fantastic starter kits!"
        logo={logoWhite}
      />
      <CreateAccountForm
        heading="Create Account"
        subheading="Enter your first name, last name, and email address below"
        image={logo}
        backgroundColor="#f8f9fa"
      />
    </div>
  </div>
);

export default SplitBackgroundImage;
